'use client';
import { ApiConfigration } from '@/hotdesk-ui/common-classes/api-configuration';
import { CalculatorService } from '@/hotdesk-ui/services/calculator.service';
import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { LongTermCalculator } from 'hotdesk_typescript';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage'; // Import directly from redux-persist
/* eslint-disable @typescript-eslint/no-explicit-any */
export interface calculator {
    userData: any;
    formData: any;
    loading: boolean;
    error: any;
    calculatedValue: LongTermCalculator | null;
}
/* eslint-disable @typescript-eslint/no-explicit-any */

export interface userData {
    country: string;
    employees: number;
    currency: string;
    workingDays: string;
    budget: number;
}

const initialState: calculator = {
    userData: {},
    formData: {},
    loading: false,
    error: null,
    calculatedValue: null
};

export const getCalculatorData = createAsyncThunk(
    'calulator/getCalculatorData',
    async ({
        userData,
        formData,
        languageCode
    }: {
        userData: any;
        formData: any;
        languageCode: string;
    }) => {
        try {
            const apiConfig = await (new ApiConfigration()).getApiConfig(
                languageCode
            );
            const service = new CalculatorService(apiConfig);
            const calculator = await service.calculate({
                numberOfEmployees: formData.employees,
                numberOfWorkdays: formData.workingDays,
                budget: formData.budget,
                currency: formData.currency,
                countryId: formData.country,
                userInformation: {
                    name: userData.name,
                    phoneNumber: JSON.stringify(userData.phone).replace(
                        / /g,
                        ''
                    ),
                    email: userData.email,
                    preferredLang: languageCode
                }
            });
            return calculator;
        } catch (error) {
            console.error('Error getting results', error);
            throw error;
        }
    }
);
export const calculatorSlice = createSlice({
    name: 'calculator',
    initialState: initialState,

    reducers: {
        setUserData: (state, action) => {
            state.userData = action.payload;
        },
        setFormData: (state, action) => {
            state.formData = action.payload;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(getCalculatorData.pending, (state) => {
                state.loading = true;
                state.error = null;
                state.calculatedValue = null;
            })
            .addCase(
                getCalculatorData.fulfilled,
                (
                    state,
                    action: PayloadAction<LongTermCalculator | undefined>
                ) => {
                    state.loading = false;
                    state.calculatedValue =
                        action.payload as LongTermCalculator;
                }
            )
            .addCase(getCalculatorData.rejected, (state, action) => {
                state.error = action.payload as string;
                state.calculatedValue = null;
                state.loading = false;
            });
    }
});

export const { setUserData, setFormData } = calculatorSlice.actions;
const persistConfig = {
    key: 'calcualtor',
    storage: storage
}

export default persistReducer(persistConfig, calculatorSlice.reducer);
